import { cn } from "@/libs/utils";

/**
 * 충전 안내 카드의 체크·엑스 아이콘.
 *
 * ⚠️ **리포의 `CheckIcon`/`CloseIcon` 을 쓰지 않는다.** 그 둘은 구세대 Material 글리프
 * (두꺼운 획 · 각진 끝)인데 시안은 Material Symbols 계열(얇은 획 · 둥근 끝)이고 24px
 * 에서도 굵기 차이가 보인다. 시안 노드 `icons/general/check` · `icons/general/close`
 * 에서 내려받은 원본이다(2026-09-14).
 *
 * 원본에서 두 가지를 고쳤다:
 * - `fill="white"` → `currentColor` — 카드 배경이 바뀌어도 따라간다
 * - check 를 감싸던 24×24 전체 마스크 제거 — 잘라내는 것이 없는 no-op 인데 DOM 에
 *   `mask0_0_43` id 를 남겨, 한 화면에 두 번 그리면 id 가 중복된다(`docs/pitfalls.md`
 *   #28 아이콘 항목).
 */
export const CheckMarkIcon = ({ className }: { className?: string }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={cn("size-6", className)}
    aria-hidden
  >
    <path
      d="M9.55 15.5155L18.1885 6.877C18.3372 6.72817 18.5112 6.65217 18.7105 6.649C18.9098 6.64583 19.0871 6.72183 19.2422 6.877C19.3974 7.03217 19.475 7.21033 19.475 7.4115C19.475 7.61283 19.3974 7.79108 19.2422 7.94625L10.1827 17.0213C10.0019 17.2019 9.791 17.2923 9.55 17.2923C9.309 17.2923 9.09808 17.2019 8.91725 17.0213L4.74225 12.8463C4.59358 12.6974 4.52025 12.5208 4.52225 12.3163C4.52408 12.1119 4.60258 11.9322 4.75775 11.777C4.91292 11.6218 5.09108 11.5443 5.29225 11.5443C5.49358 11.5443 5.67183 11.6218 5.827 11.777L9.55 15.5155Z"
      fill="currentColor"
    />
  </svg>
);

export const CrossMarkIcon = ({ className }: { className?: string }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={cn("size-6", className)}
    aria-hidden
  >
    <path
      d="M12 13.0537L6.927 18.127C6.7885 18.2653 6.61442 18.3362 6.40475 18.3395C6.19525 18.3427 6.018 18.2718 5.873 18.127C5.72817 17.982 5.65575 17.8063 5.65575 17.6C5.65575 17.3937 5.72817 17.218 5.873 17.073L10.9462 12L5.873 6.927C5.73467 6.7885 5.66383 6.61442 5.6605 6.40475C5.65733 6.19525 5.72817 6.018 5.873 5.873C6.018 5.72817 6.19367 5.65575 6.4 5.65575C6.60633 5.65575 6.782 5.72817 6.927 5.873L12 10.9462L17.073 5.873C17.2115 5.73467 17.3856 5.66383 17.5953 5.6605C17.8048 5.65733 17.982 5.72817 18.127 5.873C18.2718 6.018 18.3443 6.19367 18.3443 6.4C18.3443 6.60633 18.2718 6.782 18.127 6.927L13.0538 12L18.127 17.073C18.2653 17.2115 18.3362 17.3856 18.3395 17.5953C18.3427 17.8048 18.2718 17.982 18.127 18.127C17.982 18.2718 17.8063 18.3443 17.6 18.3443C17.3937 18.3443 17.218 18.2718 17.073 18.127L12 13.0537Z"
      fill="currentColor"
    />
  </svg>
);
